var _defs, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportingSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.75,
    height: 28,
    viewBox: "0 0 25.75 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    y2: 0.876,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1fb2ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e64ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875,4h5.5V32h-5.5Zm4.5,1h-3.5V31h3.5Z",
    transform: "translate(-5.125 -4)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125,23.125h5.5V32h-5.5Zm4.5,1h-3.5V31h3.5Z",
    transform: "translate(-5.125 -4)",
    opacity: 0.3,
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.625,18.625h5.5V32h-5.5Zm4.5,1h-3.5V31h3.5Z",
    transform: "translate(-5.125 -4)",
    opacity: 0.3,
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.375,11.875h5.5V32h-5.5Zm4.5,1h-3.5V31h3.5Z",
    transform: "translate(-5.125 -4)",
    fill: "url(#a)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingSvg);
export default __webpack_public_path__ + "static/media/ReportingSVG.834ecf72.svg";
export { ForwardRef as ReactComponent };